import styles from './TopBar.module.css';

interface TopBarProps {
  title: string;
  backLabel: string;
  onBack: () => void;
  // An optional button on the right ("Filter & sort"). The return button stays first.
  action?: { label: string; onClick: () => void };
}

// The one way back on a read screen: first in the screen and sticky at the top, so
// returning never means scrolling to the bottom. The chevron is decoration only;
// the button's accessible name is the bare label ("Home", "Back to payments", …).
export default function TopBar({ title, backLabel, onBack, action }: TopBarProps) {
  return (
    <header className={styles.bar}>
      <button type="button" className={styles.backButton} onClick={onBack}>
        <span aria-hidden="true">‹ </span>
        {backLabel}
      </button>
      <h1 className={styles.title}>{title}</h1>
      {action && (
        <button type="button" className={styles.actionButton} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </header>
  );
}
